import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const { forgotPassword } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error('Please enter your email');
            return;
        }
        setLoading(true);
        const result = await forgotPassword(email);
        setLoading(false);
        if (result.success) {
            setSent(true);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box" style={{
                maxWidth: '750px',
                padding: '45px 55px',
                width: '100%'
            }}>
                <div className="srm-logo-big" style={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%'
                }}>
                    <img
                        src="/srm-logo.png"
                        alt="SRMIST Logo"
                        style={{
                            width: '180px',
                            height: 'auto',
                            margin: '0 auto 16px',
                            display: 'block',
                            backgroundColor: 'white',
                            padding: '18px',
                            borderRadius: '16px',
                            boxShadow: '0 6px 20px rgba(0,0,0,0.18)'
                        }}
                    />
                    <div style={{
                        fontFamily: "'Times New Roman', Times, serif",
                        fontWeight: 700,
                        fontSize: '18px',
                        color: '#c9a84c',
                        textAlign: 'center',
                        letterSpacing: '1.5px',
                        marginBottom: '6px',
                        whiteSpace: 'nowrap',
                        width: '100%'
                    }}>
                        Attend360
                    </div>
                    <div style={{
                        fontFamily: "'Times New Roman', Times, serif",
                        fontWeight: 700,
                        fontSize: '20px',
                        color: '#0a1e3c',
                        textAlign: 'center',
                        letterSpacing: '0.5px',
                        whiteSpace: 'nowrap',
                        width: '100%'
                    }}>
                        SRM INSTITUTE OF SCIENCE AND TECHNOLOGY
                    </div>
                    <div style={{
                        fontFamily: "'Times New Roman', Times, serif",
                        fontWeight: 700,
                        fontSize: '14px',
                        color: '#666',
                        textAlign: 'center',
                        marginTop: '3px',
                        marginBottom: '15px',
                        whiteSpace: 'nowrap',
                        width: '100%'
                    }}>
                        DELHI - NCR CAMPUS, GHAZIABAD
                    </div>
                    <div style={{
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        fontWeight: 600,
                        textAlign: 'center',
                        color: '#666',
                        fontSize: '14px',
                        borderTop: '1px solid #eee',
                        paddingTop: '15px',
                        width: '100%'
                    }}>
                        Forgot Password
                    </div>
                </div>

                {sent ? (
                    <div style={{ textAlign: 'center' }}>
                        <p style={{ color: '#2e7d32', fontWeight: 600, margin: '20px 0' }}>
                            📧 If an account exists for {email}, a password reset link has been sent.
                        </p>
                        <p style={{ color: '#666', fontSize: '13px', marginBottom: '20px' }}>
                            Check your inbox (and spam folder). The link is valid for 1 hour.
                        </p>
                        <button
                            type="button"
                            onClick={() => navigate('/login')}
                            className="btn btn-primary"
                            style={{ width: '100%' }}
                        >
                            Back to Login
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                className="form-control"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your registered email"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: '100%' }}
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate('/login')}
                            className="btn"
                            style={{
                                width: '100%',
                                marginTop: '10px',
                                background: '#666',
                                color: 'white'
                            }}
                        >
                            Back to Login
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
